export default __webpack_public_path__ + "static/media/vipso-icon.404ef9c9.png";